
import Header from '../components/header';
import {Link} from 'react-router-dom';

function Home() {
  return (
    <div className="relative min-h-screen w-full bg-[#f5f5fd] overflow-hidden">
      <Header/>

      {/* hero section */}

        <div className="container mx-auto py-20 md:py-32">
            <div className="max-w-4xl mx-auto space-y-8 text-center">
                <div className=" text-4xl md:text-6xl font-bold tracking-tight">
                    Discover Your Next {" "} <span className="bg_Gradient bg-clip-text text-transparent">Open Source</span> {" "} Contribution    
                </div>
                <p className="text-[#65738a] text-lg md:text-xl max-w-2xl mx-auto">
                    Find projects that match your skills and interests. 
                    From beginner-friendly issues to advanced challenges, start contributing to open source today.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center item-center pt-4">
                    <Link to="/projects">
                        <button size="lg" className="h-11 rounded-md border px-8 text-lg text-white font-semibold hover:cursor-pointer" style={{background: "linear-gradient(135deg, hsl(250 95% 63%), hsl(270 90% 70%))"}}> Browse Projects </button>
                    </Link>
                    <Link to="/add_projects">
                        <button className="h-11 rounded-md border border-[#754efa] px-8 text-lg text-[#754efa] font-semibold hover:cursor-pointer"> Submit a Project </button>
                    </Link>
                </div>

                <div className="flex flex-col sm:flex-row gap-8 justify-center px-20 pt-8">
                    <div className="text-center">
                        <div className="text-[#6647fa] text-3xl font-bold">1,000+</div>
                        <p className="text-[#65738a] font-semibold">projects</p>
                    </div>

                    <div className="text-center">
                        <div className="text-[#6647fa] text-3xl font-bold">20+</div>
                        <p className="text-[#65738a] font-semibold">Languages</p>
                    </div>

                    <div className="text-center">
                        <div className="text-[#6647fa] text-3xl font-bold">100+</div>
                        <p className="text-[#65738a] font-semibold">Contributions</p>
                    </div>
                </div>
            </div>
        </div>

        <img src="/assets/wavey3.svg" alt="wavey effect" className="absolute bottom-[-45px] left-0 w-full"/>
    </div>
  );
}

export default Home;
